export const deepClone = (input: unknown) => {
    return JSON.parse(JSON.stringify(input));
};

export const isTheSameByDeepCompare = (object1: unknown, object2: unknown) => {
    return JSON.stringify(object1) === JSON.stringify(object2);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const flattenNestedObject = <T>(source: T, prefix: string): Record<string, any> => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const flatObject: Record<string, any> = {};

    Object.entries(source || {}).forEach(([key, value]) => {
        const newKey = `${prefix}.${key}`;

        if (typeof value === "object" && value !== null && !Array.isArray(value)) {
            // Recursively flatten nested objects
            Object.assign(flatObject, flattenNestedObject(value, newKey));
        } else {
            flatObject[newKey] = value;
        }
    });

    return flatObject;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const extractNestedObject = <T>(source: Record<string, any>, prefix: string): T | undefined => {
    const nestedObject: Partial<T> = {};

    Object.keys(source).forEach((key) => {
        const prefixDot = `${prefix}.`;
        if (key.startsWith(prefixDot)) {
            const newKey = key.replace(prefixDot, "");
            nestedObject[newKey as keyof T] = source[key];
        }
    });

    return Object.keys(nestedObject).length > 0 ? (nestedObject as T) : undefined;
};
